<div class="table-container" #tableHolder>
  <div class="table-wrapper">
    <table>
      <thead>
      <tr>
        <th class="">
          <span>Торгова назва</span>
        </th>
        <th>Серія/Каталожний номер</th>
        <th>Кількість у карантині</th>
        <th>Придатний до</th>
        <th>Дозування</th>
        <th>Джерело надходження</th>
        <th>Мін. облікова одиниця</th>
        <th>
          <app-filter
              [key]="'institutionIds'"
              (selectedOptionsChange)="applyFilters($event)"
          >
            Назва закладу
          </app-filter>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr *ngFor="let product of products">
        <td class="text-black">{{ product.medicineMedicalDevice.tradeName }}</td>
        <td class="text-black">{{ product.medicineMedicalDevice.series }}</td>
        <td class="text-black">{{product.amount === null ? '-' : product.amount }}</td>
        <td class="text-black">{{product.medicineMedicalDevice.dueDate | date: 'dd.MM.y'}}</td>
        <td class="text-gray">{{product.medicineMedicalDevice.dosage }}</td>
        <td class="text-gray">{{product.medicineMedicalDevice.sponsoredBy }}</td>
        <td class="text-gray">{{product.medicineMedicalDevice.minUnit || '-' }}</td>
        <td class="text-black">{{product.medicineMedicalDevice.institutionName }}</td>
      </tr>
      </tbody>
    </table>
  </div>
  <app-loading-animation *ngIf="isLoading"></app-loading-animation>
  <div class="table-footer" *ngIf="totalElements">
    <med-pagination
        [perPage]="itemsPerPage"
        [total]="totalElements"
        [page]="currentPage"
        (pageChange)="onPageChange($event)"
    />
  </div>
</div>
